import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "trading-layout-mobile"
}

import { debounce } from 'lodash/fp';
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import persistanceHelper from '@exchange/helpers/persistance-helper';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';

import { tabs as bottomNavTabs, type Tabs, type TabKeys, type TabValues } from './components/bottom-tabs';
import ExchangeBottomTabs from './components/ExchangeBottomTabs.vue';
import AppHeader from '../app-header/AppHeader.vue';

const EXCHANGE_NAV_TAB = '1T_NAV_TAB';

export default /*#__PURE__*/_defineComponent({
  __name: 'TradingLayout',
  props: {
  marketId: { type: String },
},
  setup(__props) {

const props = __props;

const route = useRoute();
const router = useRouter();

const { isXS } = useMQBreakpoints();

const DEFAULT_NAV_TAB_KEY = bottomNavTabs.MARKETS.key;

const isFutures = computed(() => route.name === 'futures');
const isSpot = computed(() => route.name === 'spot');

const getInitMobileActiveTab = () => {
  if (isSpot.value) {
    return bottomNavTabs.MARKETS.key;
  }

  const tab = Object.values(bottomNavTabs).find((e) => e.routeName === route.name)?.key;

  return tab ?? persistanceHelper.getObjFromJSON(EXCHANGE_NAV_TAB, DEFAULT_NAV_TAB_KEY);
};

const mobileSlideMoveBack = ref(true);
const mobileActiveTab = ref<TabKeys>(getInitMobileActiveTab());

const getBottomTabs = (tabs: typeof bottomNavTabs | Omit<typeof bottomNavTabs, 'FUTURES'>) =>
  (Object.keys(tabs) as Array<Tabs>).reduce(
    (acc, cur) => {
      const t = bottomNavTabs[cur];

      acc[t.key] = { ...t };

      return acc;
    },
    {} as Record<TabKeys, TabValues>,
  );

const bottomTabs = computed(() => getBottomTabs(bottomNavTabs));

const onBottomTabClicked = (tab: TabValues) => {
  const activeTabOrder = bottomTabs.value[mobileActiveTab.value]?.order;
  const newTabOrder = bottomTabs.value[tab.key]?.order;

  mobileSlideMoveBack.value = activeTabOrder !== undefined && newTabOrder !== undefined && activeTabOrder > newTabOrder;
  mobileActiveTab.value = tab.key;
  persistanceHelper.localstorageSet(EXCHANGE_NAV_TAB, tab.key);

  router.push({
    name: tab.routeName,
    hash: route.hash,
    query: route.query,
  });
};

const onMarketClicked = debounce(200, (marketId: string) => {
  const isFuturesMarket = marketId.endsWith('_P');
  const navigateToMarket = () =>
    router.push({
      name: isFuturesMarket ? 'futures' : 'spot',
      params: {
        marketId,
      },
    });

  if (isXS.value) {
    navigateToMarket();

    return;
  }

  if (marketId !== props.marketId) {
    navigateToMarket();
  }
});

const onMobileContentBack = () => {
  onBottomTabClicked(bottomNavTabs.MARKETS);
};

watch(route, (nV, oV) => {
  if (nV.name === oV.name) {
    return;
  }

  if (route.name && isXS.value) {
    const tab = Object.values(bottomNavTabs).find((e) => e.routeName === route.name);

    if (tab) {
      onBottomTabClicked(tab);
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_x_transition_slide = _resolveComponent("x-transition-slide")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(isXS))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            _createVNode(_component_x_transition_slide, {
              push: true,
              "move-back": mobileSlideMoveBack.value,
              "is-xs": true
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                  "market-id": __props.marketId,
                  class: _normalizeClass({ 'trading-layout-mobile__content': !(isFutures.value || isSpot.value) }),
                  "onMobile:goBack": onMobileContentBack,
                  onMarketClicked: _unref(onMarketClicked)
                }, null, 40, ["market-id", "class", "onMarketClicked"]))
              ]),
              _: 2
            }, 1032, ["move-back"])
          ]),
          _: 1
        }),
        _createVNode(ExchangeBottomTabs, {
          "bottom-tabs": bottomTabs.value,
          "active-tab": mobileActiveTab.value,
          "onBottomTab:clicked": onBottomTabClicked
        }, null, 8, ["bottom-tabs", "active-tab"])
      ]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(AppHeader),
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              "market-id": __props.marketId,
              onMarketClicked: _unref(onMarketClicked)
            }, null, 40, ["market-id", "onMarketClicked"]))
          ]),
          _: 1
        })
      ], 64))
}
}

})